import styled from 'styled-components';

const StyledFooter = styled.footer`
  position: relative;
  background-color: #000;
  padding: 128px 175px;
  color: #fff;
  .footer--external-link {
    color:#fff;
  }
  @media screen and (max-width: 1439px){
    padding: 128px 121px;
  }
  @media screen and (max-width: 1023px){
    padding: 80px 99px;
  }
  @media screen and (max-width: 767px){
    padding: 64px 24px;
  }
  .footer--map-wrap{
    position: relative;
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 32px 0;
    &.with--border{
      padding-top: 0;
      border-bottom: 1px solid #333333;
    }
    @media screen and (max-width: 1023px){
      padding: 32px 0;
    }
    @media screen and (max-width: 767px){
      padding: 24px 0;
    }
  }
  .footer--map-col{
    flex: 0 0 24.33%;
    p{
      padding: 12px 0;
      margin-bottom: 16px;
      &.link {
        cursor:pointer;
      }
      &.footer-address {
        padding: 0;
      }
      &:last-child{
        padding-bottom: 0;
        margin-bottom: 0;
      }
    }
   
    @media screen and (max-width: 1024px){
      p{
        &:last-child{
          padding: 12px 0;
          margin-bottom: 16px;
        }
        &.footer-address {
          padding: 0;
        }
      }
    }
    @media screen and (max-width: 767px){
      flex: 1 0 48%;
    }
  }
  .addresses-row{
    border-bottom: 1px solid #333333;
    margin-bottom: 10px;
    @media screen and (max-width: 1023px){
      border-bottom: 0;
    }
  }
  .addresses-row .footer--map-col{
    flex: 0 0 33.33%;
    @media screen and (max-width: 767px){
      flex: 1 0 100%;
    }
  }
  .addresses-row .footer--map-col p:last-child{
    margin-bottom: 0;
    padding-bottom: 0;
  }
  
  .footer--logo-col{
    position: absolute;
    right: 0;
    width: 24.33%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    @media screen and (max-width: 1024px){
      position: relative;
      width: 70%;
    }
  }
  .footer--logo-col img{
    display: block;
    width: 54%;
    max-width: 150px;
    &.footer-badge {
      width: 34%;
      margin-right: 15px;
      max-width: 115px;
    }
  }
  .footer--row-wrap{
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 32px;
    .footer--row-col{
      flex: 0 0 58%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &:nth-child(2){
        flex: 0 0 40%;
      }
      p{
        font-size: 14.4px;
      }
      .footer--row-col__mobile{
        flex: 1 1 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      @media screen and (max-width: 1023px){
        flex: 0 0 100%;
        margin-bottom: 16px;
        &:nth-child(2){
          flex: 0 0 auto;
          .footer--row-col__mobile:nth-child(1) .footer--row-col__image{
            margin-right: 16px;
            padding: 16px 0;
          }
        }
      }
      @media screen and (max-width: 767px){
        margin-bottom: 20px;
        &:nth-child(2){
          flex-direction: column;
          align-items: flex-start;
        }
        .footer--row-col__mobile{
          flex: 0 0 100%;
        }
      }
      .footer--social{
        margin-left: -14px;
      }
    }
    @media screen and (max-width: 1023px){
      flex-wrap: wrap;
      padding-bottom: 24px;
    }
    @media screen and (max-width: 767px){
      padding-bottom: 0;
      
    }
  }
  @media screen and (max-width: 767px){
    .addresses-row .footer--map-col p.no-margin-mobile{
      margin: 0;
      padding: 0;
    }
  }
`;

export {
  StyledFooter,
};

